import { render, staticRenderFns } from "./RPlist.vue?vue&type=template&id=580a31de&scoped=true"
import script from "./RPlist.vue?vue&type=script&lang=js"
export * from "./RPlist.vue?vue&type=script&lang=js"
import style0 from "./RPlist.vue?vue&type=style&index=0&id=580a31de&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580a31de",
  null
  
)

export default component.exports